import get from "lodash.get";

// const example = {
//     isValid: false,
//     quantity: '',
//     partner: {
//         isValid: false,
//         dealer: {
//             isValid: false,
//             cui:'Manadatory',
//             contactInfo: {
//                 isValid:false,
//                 email: 'Manadatory',
//                 name: ''
//             }
//         }
//     },
//     supplier: {
//         isValid: false,
//         dealer: {
//             isValid: false,
//             email: 'Manadatory',
//             name: ''
//         }
//     }
// }

// type ValidationInfo =
//   | Simple of string
//   | Complex of ValidationInfo

export function create(isValid = true) {
  return { isValid };
}

export function update(property, propertyValidationInfo, validationInfo) {
  if (propertyValidationInfo === validationInfo[property]) {
    return validationInfo;
  }

  const updated = {
    ...validationInfo,
    [property]: propertyValidationInfo
  };

  const isValidChanged = getIsValid(validationInfo[property]) !== getIsValid(propertyValidationInfo);
  return isValidChanged
    ? {
        ...updated,
        isValid: reduceIsValid(updated)
      }
    : updated;
}

export function merge(sourceValidationInfo, targetValidationInfo) {
  if (sourceValidationInfo === targetValidationInfo) {
    return targetValidationInfo;
  }

  if (targetValidationInfo === null || targetValidationInfo === undefined) {
    return sourceValidationInfo;
  }

  if (typeof sourceValidationInfo === "string") {
    return sourceValidationInfo;
  }

  const result = Object.keys(sourceValidationInfo)
    .filter(x => x !== "isValid")
    .reduce(
      (accumulator, property) =>
        update(property, merge(sourceValidationInfo[property], targetValidationInfo[property]), accumulator),
      targetValidationInfo
    );
  return result;
}

export function getPropertyValidationError(propertyPath, validationInfo) {
  return get(validationInfo, propertyPath);
}

export function propertyHasValidationError(propertyPath, validationInfo) {
  return !isPropertyValid(propertyPath, validationInfo);
}

function isPropertyValid(propertyPath, validationInfo) {
  return getPropertyValidationError(propertyPath, validationInfo) ? false : true;
}

function reduceIsValid(validationInfo) {
  const isValid = Object.keys(validationInfo)
    .filter(x => x !== "isValid")
    .every(x => getIsValid(validationInfo[x]));
  return isValid;
}

function getIsValid(validationInfo) {
  if (validationInfo === null || validationInfo === undefined) {
    return true;
  }
  return typeof validationInfo === "string" ? validationInfo === "" : validationInfo.isValid;
}
